import { useQuery } from '@tanstack/react-query';

import { getPropertyCoverages } from '@/shared/services';
import type { CoverageRule } from '@/shared/types';

const QUERY_KEY = 'propertyCoverages';
const STALE_TIME = 10 * 60 * 1000;

export const useCoverageRules = (propertyId: string | undefined) => {
  return useQuery<CoverageRule[]>({
    queryKey: [QUERY_KEY, propertyId],
    queryFn: () => getPropertyCoverages(propertyId!),
    enabled: Boolean(propertyId),
    staleTime: STALE_TIME,
    retry: false,
  });
};
